import React from 'react';
import { motion } from 'framer-motion';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const cards = [
    {
      icon: '🧘',
      title: 'Expert Guidance',
      desc: 'Learn from certified yoga instructors.'
    },
    {
      icon: '🌿',
      title: 'Peaceful Space',
      desc: 'Practice in a calm and relaxing environment.'
    },
    {
      icon: '❤️',
      title: 'Healthy Living',
      desc: 'Improve flexibility, strength, and wellness.'
    },
    {
      icon: '🕒',
      title: 'Flexible Classes',
      desc: 'Morning, evening, and weekend sessions.'
    },
    {
      icon: '🌸',
      title: 'Personal Growth',
      desc: 'Build confidence, focus, and inner peace.'
    },
    {
      icon: '🤝',
      title: 'Supportive Community',
      desc: 'Grow together with like-minded members.'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <section className="why-choose-us">
      <div className="wcu-container">
        <motion.div 
          className="wcu-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <h4 className="wcu-subtitle">Why Choose Us</h4>
          <h2 className="wcu-title">Discover the Power of Yoga</h2>
          <p className="wcu-desc">
            Simple practices for a healthier, happier, and more balanced life.
          </p>
          <div className="wcu-divider"></div>
        </motion.div>

        <motion.div 
          className="wcu-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {cards.map((card, index) => (
            <motion.div key={index} className="wcu-card" variants={itemVariants}>
              <div className="wcu-icon">{card.icon}</div>
              <h3 className="wcu-card-title">{card.title}</h3>
              <p className="wcu-card-desc">{card.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
